import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import { Row, Column } from '@nobia/zeus-components/lib/grid'
import { cdnImage } from '../../utils'

const removeImage = cdnImage(require('../../assets/close.svg'))

const RemoveButton = styled.img`
  width: 18px;
  height: 18px;
  vertical-align: middle;
  border: 0;
`

const Wrapper = styled.div`
  border-bottom: 1px solid gray;
  width: 100%;
  padding: 0 20px;
`

const CustomInfoColumn = styled(Column)`
  padding: 20px 10px;
  display: flex;
`

const CustomImageColumn = styled(Column)`
  padding: 10px 5px 10px 5px;
  margin-left: 2%;
  display: flex;
`

const CustomButtonColumn = styled(Column)`
  padding: 0 16px;
  width: 12%;
  display: flex;
  align-items: center;
`

const CustomRow = styled(Row)`
  text-align: left;
`

const NameLabel = styled.label`
  font-size: 16px;
`

const PriceLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
`

const Image = styled.img`
  width: 100%;
  max-width: 100px;
  max-height: 70px;
  object-fit: contain;
`

class ProductRow extends Component {
  onRemove = () => {
    this.props.handleRemove(this.props.item.id) // todo: to be replaced by id
  }

  render() {
    return (
      <Wrapper>
        <Row>
          <CustomImageColumn xs={3}>
            <Image
              src={`https://res.cloudinary.com/dgg9enyjv/image/upload/c_fill,w_80/Magnet/PIMImages/${
                this.props.item.images[0]
              }.jpg`}
            />
          </CustomImageColumn>
          <CustomInfoColumn xs={7}>
            <CustomRow>
              <Column>
                <NameLabel>{this.props.item.name}</NameLabel>
              </Column>
              <Column>
                <PriceLabel>£ {this.props.item.price}</PriceLabel>
              </Column>
            </CustomRow>
          </CustomInfoColumn>
          <CustomButtonColumn>
            <RemoveButton src={removeImage} onClick={this.onRemove} />
          </CustomButtonColumn>
        </Row>
      </Wrapper>
    )
  }
}

ProductRow.propTypes = {
  item: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  handleRemove: PropTypes.func.isRequired,
}

ProductRow.defaultProps = {}

export default ProductRow
